"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionDtoSchema = void 0;
const account_copies_model_1 = require("../domain/account-copies.model");
const account_model_1 = require("../domain/account.model");
const account_integration_model_1 = require("./account-integration.model");
const yup_lib_1 = __importDefault(require("../yup-lib"));
exports.PromotionDtoSchema = yup_lib_1.default.object().shape({
    account: account_model_1.AccountSchema.required(),
    interceptors: yup_lib_1.default.array().of(account_copies_model_1.AccountCopySchema).notRequired(),
    integrations: yup_lib_1.default.array().of(account_integration_model_1.AccountIntegrationSchema).notRequired()
});
